import React, { Component } from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import privacySimplePackage from "../docs/shuttleid-simple-package-privacy-policy-updated-may-2025.pdf";
import privacyCompletePackage from "../docs/shuttleid-complete-package-privacy-policy-updated-august-2025.pdf";
import "./index.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Hero from "../components/hero-standard"
import Nav from "../components/nav"
import Footer from "../components/footer"

class BlogPage extends Component {

  componentDidMount(){
    AOS.init({
      duration : 2000
    });
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="Privacy notice" />
        <Nav />
        <div>
            <div>

              <div>

                <Hero h1="Privacy notice" h2="Protecting your data" />

                <div className="article">
                  <div className='article-inner' style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: '1.3em', color: '#3f6375', lineHeight: '150%' }}>Access the ShuttleID privacy notice below:</p>
                    <p><a href={privacyCompletePackage}>Privacy Policy - Complete Package</a></p>
                    <p><a href={privacySimplePackage}>Privacy Policy - Simple Package</a></p>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <Footer />
      </Layout>
    );
  }
};

export default BlogPage
